var _path, _rect, _rect2, _rect3, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKnife(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 298.9 298.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M189.1,173.85h-9.15V45.75c0-18.898-9.753-32.85-28.204-40.345C138.593,0.062,125.597,0,125.05,0 c-3.369,0-6.1,2.731-6.1,6.1v167.75h-9.15c-6.727,0-12.2,5.473-12.2,12.2v15.25c0,3.369,2.731,6.1,6.1,6.1h15.25v79.3 c0,6.727,5.473,12.2,12.2,12.2h36.6c6.727,0,12.2-5.473,12.2-12.2v-79.3h15.25c3.369,0,6.1-2.731,6.1-6.1v-15.25 C201.3,179.323,195.827,173.85,189.1,173.85z M131.15,12.667c1.778,0.222,3.855,0.551,6.1,1.035V94.55h12.2V17.709 c12.306,5.727,18.3,14.921,18.3,28.041v128.1h-36.6V12.667z M167.75,216.55H146.4v12.2h21.35v12.2H146.4v12.2h21.35v12.2H146.4 v12.2h21.35v9.15h-36.6v-79.3h36.6V216.55z M189.1,195.2h-79.3v-9.15h79.3V195.2z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 152.5,
    y: 152.5,
    width: 12.2,
    height: 12.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 134.2,
    y: 152.5,
    width: 12.2,
    height: 12.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 152.5,
    y: 134.2,
    width: 12.2,
    height: 12.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 152.5,
    y: 115.9,
    width: 12.2,
    height: 12.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnife);
export default __webpack_public_path__ + "static/media/knife.148392182e5dc2872ea06507e2b7370b.svg";
export { ForwardRef as ReactComponent };